import { CustomerDevice } from "@/models/Common";
import { AvailableJob, CurrentJob, JobsContextItem, JobsFilters, JobsState, Timeslot } from "@/models/JobsState"

export const JobsGetters = {
	GET_JOBS_LIST: 'GET_JOBS_LIST',
	GET_SELECTED_CONTEXT: 'GET_SELECTED_CONTEXT',
	GET_CURRENT_JOB: 'GET_CURRENT_JOB',
	GET_MY_JOBS_FILTERS: 'GET_MY_JOBS_FILTERS',
	GET_JOB_TIMESLOTS: 'GET_JOB_TIMESLOTS',
	GET_CUSTOMER_DEVICES_MAP: 'GET_CUSTOMER_DEVICES_MAP',
	GET_TOTAL_JOBS: 'GET_TOTAL_JOBS',
	GET_JOB_TIMESLOTS_AMOUNT: 'GET_JOB_TIMESLOTS_AMOUNT'
}

export default {
	[JobsGetters.GET_JOBS_LIST]: (state: JobsState): AvailableJob[] => {
		return state.jobs;
	},
	[JobsGetters.GET_TOTAL_JOBS]: (state: JobsState): number => {
		return state.total_jobs;
	},
	[JobsGetters.GET_SELECTED_CONTEXT]: (state: JobsState): JobsContextItem => {
		return state.context;
	},
	[JobsGetters.GET_CURRENT_JOB]: (state: JobsState): CurrentJob | null => {
		return state.current_job;
	},
	[JobsGetters.GET_MY_JOBS_FILTERS]: (state: JobsState): Set<JobsFilters> => {
		return state.filters;
	},
	[JobsGetters.GET_JOB_TIMESLOTS]: (state: JobsState): Timeslot[] => {
		return state.current_job?.details.timeslots || [];
	},
	[JobsGetters.GET_JOB_TIMESLOTS_AMOUNT]: (state: JobsState): number => {
		return state.current_job?.details.timeslots.length || 0;
	},
	[JobsGetters.GET_CUSTOMER_DEVICES_MAP]: (state: JobsState): { [key: string]: CustomerDevice } => {
		return state.current_job?.devices.reduce((acc: any, next: CustomerDevice) => {
			acc[next.customerDeviceId] = next
			return acc;
		}, {})
	}
}
